export default {
  id : 'ps.AlertsQueryHandler',
  matches : {
    objectType : 'store',
    client : 'ps.AlertsEvents'
  },
  handle( cxt ) {
    return {
      where : [
        [
          'or',
          [
            [ '$type', '=', 'safety' ],
            [ '$type', '=', 'product' ]
          ]
        ]
      ],
      paths : [
        '$id',
        '$deviceId',
        '$blueprintId',
        '$time',
        '$receivedTime',
        '$storedTime',
        '$type',
        '$data',
        '$event.userId',
        '$event.source',
        '$ack.id',
        '$ack.userId',
        '$ack.source',
        '$ack.time',
        [
          '$ack.data',
          'ackData',
          null,
          'object'
        ]
      ],
      ack : true
    }
  }
}
